import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography, Button, Grid } from '@material-ui/core';
import CenteredFullScreen from '../../common/component/centered-full-screen';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    spaced: {
        marginTop: theme.spacing(2),
    },
    button: {
        margin: theme.spacing(2),
    },
}));

function NoMatch(props) {

    const classes = useStyles();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500);
        return () => clearTimeout(timer);
    }, []);

    return (
        <CenteredFullScreen>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant='h5' component='h3'>404 ...</Typography>
                    <Typography>The page you want to access doesn't exist</Typography>
                </Grid>
                <Grid className={classes.spaced} item xs={12}>
                    {loading ?
                        <CircularProgress />
                        :
                        <Button className={classes.button} variant='outlined' onClick={() => {
                            window.location.replace('/');
                        }}>Go Home</Button>
                    }
                </Grid>
            </Grid>
        </CenteredFullScreen>
    );
}


export default NoMatch;